import { render, staticRenderFns } from "./viewAktivenAliases.vue?vue&type=template&id=6435a01e&"
import script from "./viewAktivenAliases.vue?vue&type=script&lang=js&"
export * from "./viewAktivenAliases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports